export const OrderTypeTag = ({ type, testid }) => {
  const isService = String(type || "Product").trim().toLowerCase() === "service";
  return (
    <span
      className={`inline-flex items-center rounded px-1.5 py-0.5 text-[9.5px] font-bold uppercase tracking-wider ${isService ? "bg-pink-100 text-pink-700 border border-pink-200" : "bg-sky-100 text-sky-700 border border-sky-200"}`}
      data-testid={testid}
    >
      {isService ? "Service" : "Product"}
    </span>
  );
};
